// 颜色常量
export const COLORS = {
  green: {
    dark: '#004d40',
    medium: '#00695c',
    light: '#00897b',
  },
  gold: {
    bright: '#ffd700',
    medium: '#ffb300',
    dark: '#ff8f00',
  },
  red: {
    dark: '#b71c1c',
    medium: '#c62828',
    light: '#e53935',
  },
  white: '#fafafa',
  silver: '#c0c0c0',
  blue: '#1565c0',
} as const

// 场景配置
export const SCENE_CONFIG = {
  camera: {
    position: [0, 4, 20] as [number, number, number],
    fov: 45,
    near: 0.1,
    far: 1000,
  },
  lights: {
    ambient: { intensity: 0.08 }, // 进一步降低环境光
    directional: {
      position: [10, 20, 10] as [number, number, number],
      intensity: 0.5, // 进一步降低主光源
    },
    points: [
      { position: [5, 10, 5] as [number, number, number], color: '#ffd700', intensity: 0.3 }, // 大幅降低点光源
      { position: [-5, 8, -5] as [number, number, number], color: '#ff8f00', intensity: 0.2 },
    ],
  },
} as const

// 树配置
export const TREE_CONFIG = {
  height: 12,
  baseRadius: 5,
  topRadius: 0.5,
  segments: 8,
  particleCount: 1500, // 进一步减少针叶粒子数量，让图片和金属球成为主角
  chaosRadius: 15,
} as const

// 装饰物配置
export const ORNAMENT_CONFIG = {
  gifts: {
    count: 40,
    minScale: 0.3,
    maxScale: 0.6,
    weight: 0.3, // 重
    colors: [COLORS.red.dark, COLORS.gold.bright, COLORS.green.dark, COLORS.blue],
  },
  baubles: {
    count: 100,
    minScale: 0.15,
    maxScale: 0.35,
    weight: 0.7, // 轻
    colors: [COLORS.gold.bright, COLORS.red.medium, COLORS.silver, COLORS.blue],
  },
  lights: {
    count: 80, // 减少灯光数量
    minScale: 0.03, // 减小灯光尺寸
    maxScale: 0.06,
    weight: 0.9, // 极轻
    colors: [COLORS.gold.bright, COLORS.white, '#ffeb3b', '#fff9c4'],
  },
} as const

// 动画配置
export const ANIMATION_CONFIG = {
  transitionDuration: 2.5, // 秒
  transitionSpeed: 0.5, // 每帧进度增量的基础值
  easing: 'easeInOut' as const,
  staggerDelay: 0.02, // 每个元素的延迟
} as const

// Bloom 后期处理配置 - 星星点点效果
export const BLOOM_CONFIG = {
  intensity: 0.15, // 非常低的辉光强度
  threshold: 0.98, // 非常高的阈值，只有最亮的才发光
  smoothing: 0.2, // 减少平滑，让光点更锐利
} as const

// 后期处理配置
export const POST_PROCESSING_CONFIG = {
  bloom: {
    luminanceThreshold: 0.95, // 非常高的阈值
    luminanceSmoothing: 0.1, // 减少平滑
    intensity: 0.3, // 低强度
  },
  vignette: {
    offset: 0.1,
    darkness: 0.7, // 增加暗角效果，让边缘更暗
  },
} as const

// 手势检测配置
export const HAND_TRACKING_CONFIG = {
  maxHands: 1,
  modelComplexity: 1,
  minDetectionConfidence: 0.7,
  minTrackingConfidence: 0.5,
} as const

// 拍立得照片配置
export const POLAROID_CONFIG = {
  count: 6,
  width: 1.2,
  height: 1.5,
  borderWidth: 0.1,
  bottomBorder: 0.3,
} as const